import { render, staticRenderFns } from "./AvatarPack.vue?vue&type=template&id=05ff4786&scoped=true&"
import script from "./AvatarPack.vue?vue&type=script&lang=js&"
export * from "./AvatarPack.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPack.vue?vue&type=style&index=0&id=05ff4786&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff4786",
  null
  
)

export default component.exports